export default "__VITE_ASSET__D0ilFBe___"